import React, { useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import ContainerWithBackground from 'on_web/components/shared/Common/ContainerWithBackgroundImg';
import Header from 'on_web/components/shared/Menu/Header/Header';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import { introScreensTimeout } from 'on_web/helpers/constants';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';

import { useTranslation } from 'react-i18next';

import {
  onboardingEndAnimation,
  onboardingEndBackground,
} from 'on_web/assets/imageList';

import { ROUTE_ASSESSMENT_HOME } from 'routes';
import useUsersApi from 'on_web/hooks/useUsersApi';
import useInterval from 'on_web/hooks/useInterval';

function DnaWelcome(props) {
  const { t } = useTranslation();
  const useStyles = makeStyles(theme => ({
    mainTitle: {
      marginLeft: '10%',
      marginBottom: '20px',
      fontFamily: 'MuseoSans-900',
      fontSize: 34,
    },
    subtitle: {
      fontFamily: 'MuseoSans',
      fontSize: '21px',
      marginLeft: '10%',
      fontWeight: 'normal',
      color: 'white',
    },
    shifted: {
      marginTop: '10px',
    },
    bold: {
      fontWeight: 'bold',
    },
  }));

  const [accountCreated, setAccountCreated] = useState(false);

  const [{ partialUpdateUserData, saveReports }] = useUsersApi();

  useEffect(() => {
    partialUpdateUserData({
      user_metadata: { onboarding: { onboardingFinished: true } },
    })
      .then(() => saveReports({ report_code: 'spare', language: 'en' }))
      .then(() => {
        setAccountCreated(true);
        trackEvent('Completed Onboarding', 'User has completed onboarding');
      });
  }, [partialUpdateUserData, saveReports]);

  /**
   * Periodically checks if account creation is finished and if it is, redirect the user.
   */
  useInterval(() => {
    if (accountCreated) {
      props.history.push(ROUTE_ASSESSMENT_HOME);
    }
  }, introScreensTimeout);

  const classes = useStyles();

  return (
    <div>
      <Grid container direction="row" justify="center" alignItems="center">
        <PageItemContainer>
          <Header />

          <ContainerWithBackground
            image={onboardingEndBackground}
            maxWidth={'657px'}
            maxHeight={'658px'}
            height={'85vh'}
            width={'100vw'}
            marginTop={'1vh'}
          >
            <Box
              color="#ffffff"
              maxWidth="350px"
              position="relative"
              pr={{ xs: 2 }}
              pl={{ xs: 2 }}
              left={{ sm: '27%' }}
              top={{ sm: '12%', xs: '12%' }}
            >
              <Typography variant="h4" className={classes.mainTitle}>
                {t('onboarding.endSection.endIntro.mainTitleText')}
              </Typography>
              <Typography className={classes.subtitle}>
                {t('onboarding.endSection.endIntro.subTitleText')}{' '}
                <span className={classes.bold}>
                  {t('onboarding.endSection.endIntro.subTitleBoldPartText')}
                </span>
              </Typography>
              <Box justifyContent="center" display="flex">
                <img
                  src={onboardingEndAnimation}
                  alt="intro animation"
                  className={classes.shifted}
                  width="300px"
                />
              </Box>
            </Box>
          </ContainerWithBackground>
        </PageItemContainer>
      </Grid>
    </div>
  );
}

export default DnaWelcome;
